import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { Users, ChangePassword, ResetPassword, CreateCustomer as CreateCustomerService } from '../../../client/services';
import { setItem } from '../../../utils/localStorage';
import { toastHandler } from '../../../utils/toastHandler';
import { CreateUsers, UpdateUserProfile, FindUserList, UpdateUserPassword, CreateCustomer } from './interfaces';

export const createUsers = createAsyncThunk(
    'users/createUsers',
    async (values: CreateUsers, { rejectWithValue }) => {
        try {
            const response = await Users.create(values);
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

export const createCustomer = createAsyncThunk(
    'users/createCustomer',
    async (values: CreateCustomer, { rejectWithValue }) => {
        try {
            const response = await CreateCustomerService.create(values);
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

export const updateUserProfile = createAsyncThunk(
    'users/updateUserProfile',
    async ({ id, ...values }: UpdateUserProfile, { rejectWithValue }) => {
        try {
            const response = await Users.patch(id, values);
            
            // Only update localStorage if the user is updating their own profile
            const currentUserInfo = localStorage.getItem('info');
            if (currentUserInfo) {
                try {
                    const currentUser = JSON.parse(currentUserInfo);
                    if (currentUser && currentUser.id === id) {
                        setItem('info', response);
                    }
                } catch (error) {
                    // If JSON parsing fails, just skip localStorage update
                    console.warn('Failed to parse current user info from localStorage');
                }
            }
            
            toast.success('Profile updated successfully.');
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

export const updateUserPassword = createAsyncThunk(
    'users/updateUserPassword',
    async ({ id, ...values }: UpdateUserPassword, { rejectWithValue }) => {
        try {
            const response = await ChangePassword.patch(id, values);
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

export const findUser = createAsyncThunk(
    'users/findUser',
    async (values: FindUserList, { rejectWithValue }) => {
        try {
            const response = await Users.find({
                query: values,
            });
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);
export const getUser = createAsyncThunk(
    'users/getUser',
    async (
        values: { id: string },
        { rejectWithValue }
    ) => {
        try {
            const response = await Users.get(values.id);
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);


// Reset-password
export const createResetPassword = createAsyncThunk(
    'users/createResetPassword',
    async (email: string, { rejectWithValue }) => {
        try {
            const response = await ResetPassword.create({ email });
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);
export const patchResetPassword = createAsyncThunk(
    'users/patchResetPassword',
    async (
        { id, ...body }: { id: null; email: string; otp: string },
        { rejectWithValue }
    ) => {
        try {
            const response = await ResetPassword.patch(id, body);
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);
export const updateResetPassword = createAsyncThunk(
    'users/updateResetPassword',
    async (
        {
            id,
            ...body
        }: { id: string; email: string; otp: string; password: string },
        { rejectWithValue }
    ) => {
        try {
            const response = await ResetPassword.update(id, body);
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);
export const searchUsers = createAsyncThunk(
    'users/searchUsers',
    async (values: FindUserList, { rejectWithValue }) => {
        try {
            const response = await Users.find({
                query: values,
            });
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);
